export default "__VITE_ASSET__55102cf1__"